import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const CommonNavBar = (props) => {
  const { decodedToken, isSidebarOpen } = props;
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);

  useEffect(() => {
    // Retrieve the active menu from localStorage on load
    const savedMenu = localStorage.getItem("activeMenu");
    if (savedMenu) {
      setActiveMenu(savedMenu);
    }
  }, []);

  const toggleMenu = (menuId) => {
    if (activeMenu === menuId) {
      // Close the menu if it's already open
      setActiveMenu(null);
      localStorage.removeItem("activeMenu");
    } else {
      // Open the selected menu
      setActiveMenu(menuId);
      localStorage.setItem("activeMenu", menuId);
    }
  };
  return (
    <>
      {(decodedToken.UsrRoleId === 11) && (
        <>
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#dmexecutive"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="dmexecutive"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-clients">Influencer</span>
            </a>
            <div className="collapse menu-dropdown" id="dmexecutive">
              <ul className="nav nav-sm flex-column">
                {/* <li className="nav-item">
                  <Link
                    to="/active-influencer"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Active Influencer{" "}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/assigned-influencer"
                    className="nav-link"
                    data-key="t-ecommerce"
                  >
                    Assigned Influencer
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/pending-influencer"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Pending Influencer{" "}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/inactive-influencer"
                    className="nav-link"
                    data-key="t-crm"
                  >
                    Inactive Influencer{" "}
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link
                    to="/all-influencer"
                    className="nav-link"
                    data-key="t-ecommerce"
                  >
                    All Influencer
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          
          
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#infrequest"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="sidebarVideos"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-videos">Sub Request</span>
            </a>
            <div className="collapse menu-dropdown" id="infrequest">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link
                    to="/suggested-influencer"
                    className={`nav-link`}
                    data-key="t-ecommerce"
                  >
                    Influencer Sub Request
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item">
                  <Link className="nav-link menu-link" to="/influencer-register">
                    <i className="ri-dashboard-2-line"></i>
                    <span data-key="t-dashboard">Influencer Register</span>
                  </Link>
                </li>
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#suggestedInf"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="suggestedInf"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-clients">Suggested Influencer</span>
            </a>
            <div className="collapse menu-dropdown" id="suggestedInf">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link
                    to="/client-sub-request-in-dm-tl"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Suggested Influencer
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/approved-client-sub-request-in-dm-tl"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Approved Influencer
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/rejected-client-sub-request-in-dm-tl"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Rejected Influencer
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#suggestedclient"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="suggestedclient"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-clients">Internal Bidding</span>
            </a>
            <div className="collapse menu-dropdown" id="suggestedclient">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link
                    to="/ongoing-onboarding-bidding-list"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Ongoing
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/completed-onboarding-bidding-list"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Completed{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          
        </>
      )}

      {decodedToken?.UsrRoleId === 12 && (
        <>
        <li className="nav-item">
                <Link className="nav-link menu-link" to="/influencer-register">
                  <i className="ri-dashboard-2-line"></i>
                  <span data-key="t-dashboard">Influencer Register</span>
                </Link>
              </li>
          {/* <li className="nav-item has-submenu">
            <Link className="menu-link">
              <i className="ri-rocket-line"></i>
              <span data-key="t-videos">Sub Request</span>
            </Link>
            <div className="collapse menu-dropdown" id="infrequest">
              <ul className="nav nav-sm flex-column submenu">
                <li className="nav-item">
                  <Link
                    to="/suggested-influencer"
                    className={`nav-link ${location.pathname === "/suggested-influencer" ? "active" : ""}`}
                    data-key="t-ecommerce"
                  >
                    Influencer Sub Request
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#infrequest"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="sidebarVideos"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-videos">Sub Request</span>
            </a>
            <div className="collapse menu-dropdown" id="infrequest">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                   <Link
                    to="/suggested-influencer"
                    className={`nav-link ${location.pathname === "/suggested-influencer" ? "active" : ""}`}
                    data-key="t-ecommerce"
                  >
                    Influencer Sub Request
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#clientinfreq"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="sidebarVideos"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-videos">Suggested Influencer</span>
            </a>
            <div className="collapse menu-dropdown" id="clientinfreq">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link
                    to="/approved-influencer"
                    className={`nav-link ${location.pathname === "/approved-influencer" ? "active" : ""}`}
                    data-key="t-ecommerce1"
                  >
                    Approved Influencer
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#suggestedclient"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="suggestedclient"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-clients">Internal Bidding</span>
            </a>
            <div className="collapse menu-dropdown" id="suggestedclient">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link
                    to="/ongoing-onboarding-bidding-list"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Ongoing
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/completed-onboarding-bidding-list"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Completed{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </>
      )}
    </>
  );
};

export default CommonNavBar;
